





























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'

@Component
export default class ColumnPipeline extends Vue {
    @Prop({ required: true }) referral!: Referral
    @Prop({ default: true }) showCommentsPopup!: boolean
    @Prop({ default: true }) showPriorityPopup!: boolean

    routeToDetail(referral: Referral) {
        return {
            name: 'tasks_detail',
            params: {
                referralId: referral.id,
                contactId: referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }
}
